module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"WidgetSettings":{"titleSystemWidgets":"Системные виджеты","titleExternalWidgets":"Внешние виджеты"}},"en_us":{"WidgetSettings":{"titleSystemWidgets":"System widgets","titleExternalWidgets":"External widgets"}}}')
  delete Component.options._Ctor
}
